
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '@/components/Layout/Layout';
import ServicesHero from '@/components/Services/ServicesHero';
import ServicesFeatures from '@/components/Services/ServicesFeatures';
import ServicesOverview from '@/components/Services/ServicesOverview';
import ServiceDetails from '@/components/Services/ServiceDetails';
import FinancingSection from '@/components/Services/FinancingSection';
import LocalServicesSection from '@/components/Services/LocalServicesSection';
import EcoFriendlySection from '@/components/Services/EcoFriendlySection';
import WhyChooseSection from '@/components/Services/WhyChooseSection';
import AuthorityReferences from '@/components/Services/AuthorityReferences';
import ServicesCTA from '@/components/Services/ServicesCTA';

const ServicesPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Professional Roofing Services | Carolina Trophy Roofs | Eastern NC</title>
        <meta name="description" content="Comprehensive roofing services in Eastern NC: roof replacement, repair, inspection, storm damage restoration, commercial & residential roofing. Licensed, insured, and locally trusted since 2010." />
        <meta name="keywords" content="roofing services, roof replacement, roof repair, storm damage, commercial roofing, residential roofing, Eastern NC, Rocky Mount, Greenville" />
        <link rel="canonical" href="https://carolinatrophyroofs.com/services" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Professional Roofing Services | Carolina Trophy Roofs | Eastern NC" />
        <meta property="og:description" content="Comprehensive roofing services in Eastern NC: roof replacement, repair, inspection, storm damage restoration, commercial & residential roofing." />
        <meta property="og:url" content="https://carolinatrophyroofs.com/services" />
        <meta property="og:type" content="service" />
        
        {/* Twitter */}
        <meta name="twitter:title" content="Professional Roofing Services | Carolina Trophy Roofs | Eastern NC" />
        <meta name="twitter:description" content="Comprehensive roofing services in Eastern NC: roof replacement, repair, inspection, storm damage restoration, commercial & residential roofing." />
        
        {/* Schema.org Service Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Professional Roofing Services in Eastern North Carolina",
            "description": "Comprehensive roofing services including replacement, repair, inspection, and storm damage restoration in Eastern North Carolina.",
            "provider": {
              "@type": "RoofingContractor",
              "name": "Carolina Trophy Roofs",
              "telephone": "+1-252-302-2003",
              "url": "https://carolinatrophyroofs.com"
            },
            "areaServed": [
              { "@type": "City", "name": "Rocky Mount, NC" },
              { "@type": "City", "name": "Greenville, NC" },
              { "@type": "City", "name": "Wilson, NC" }
            ]
          })}
        </script>
      </Helmet>
      <ServicesHero />
      <ServicesFeatures />
      <ServicesOverview />
      <ServiceDetails />
      <FinancingSection />
      <LocalServicesSection />
      <EcoFriendlySection />
      <WhyChooseSection />
      <AuthorityReferences />
      <ServicesCTA />
    </Layout>
  );
};

export default ServicesPage;
